import { type FC, useMemo } from 'react';
import { LivePDFPreviewController } from '@features/live-pdf-preview';

import { useRegisterTab } from '../hooks/useRegisterTab';
import type { TabSlotProps } from '../types';

interface ContractComparisonTabProps extends TabSlotProps {
  documentUrl?: string;
  documentVersion?: number;
  expectedVersion?: number;
  label: string;
  onDownload: () => Promise<void>;
}

export const ContractComparisonTab: FC<ContractComparisonTabProps> = ({
  documentUrl,
  documentVersion,
  expectedVersion,
  id,
  isActive,
  label,
  onDownload,
  pageWidth,
  placement,
}) => {
  const registration = useMemo(
    () => ({
      id,
      label,
      fileName: label,
      documentUrl,
      documentVersion,
      shouldHideVersionBadge: true,
      onDownload,
    }),
    [id, label, documentUrl, documentVersion, onDownload],
  );

  useRegisterTab(registration);

  if (!isActive) return null;

  return (
    <LivePDFPreviewController
      documentUrl={documentUrl}
      documentVersion={documentVersion}
      expectedVersion={expectedVersion}
      onDownload={onDownload}
      pageWidth={pageWidth}
      placement={placement}
    />
  );
};
